/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Nav_DescInputs */

const en_mk_tb_nav_desc = /** @type {(inputs: Mk_Tb_Nav_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human owners, personal AI tools, shared progress and reviews.`)
};

const id_mk_tb_nav_desc = /** @type {(inputs: Mk_Tb_Nav_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penanggung jawab manusia, AI masing-masing, progres dan review bersama.`)
};

/**
* | output |
* | --- |
* | "Human owners, personal AI tools, shared progress and reviews." |
*
* @param {Mk_Tb_Nav_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_nav_desc = /** @type {((inputs?: Mk_Tb_Nav_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Nav_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_nav_desc(inputs)
	return en_mk_tb_nav_desc(inputs)
});